import {Spinner} from "react-bootstrap";

const SpinnerBootrap = () => {
    return <Spinner animation="border" variant="primary"/>
}

export default SpinnerBootrap;


